/**
 * Check a value against a regular expression
 *
 * @param {string} value value we're going to pass through the regex
 * @param {string} regularExpression regular expression we're going to use to test the value
 * @returns
 */
function regex(value: string, regularExpression: string) {
  if (value && regularExpression && typeof value === 'string' && typeof regularExpression === 'string') {
    const reg = new RegExp(regularExpression);

    console.log('------regex.val: ', value,', regex.reg: ', regularExpression, ', regex.res: ', reg.test(value));

    return reg.test(value);
  }

  return undefined;
}

export default regex;
